import InvoiceReceived from 'components/InvoiceReceived';
import Wrapper from 'components/Wrapper';

function InvoiceReceivedPage() {
  return (
    <Wrapper>
      <InvoiceReceived />
    </Wrapper>
  );
}

export default InvoiceReceivedPage;  
